import { Spin } from 'antd'
import React from 'react'
import InfiniteScroll from 'react-infinite-scroll-component'

import { SectionType, useGetTimelinePostsQuery, useGetViewerQuery } from '@/generated/graphql'
import { PostCard } from '@/modules/post/post-card'

import s from './archive.module.less'

export const ArchivePosts = () => {
  const last = 20
  const { data: me } = useGetViewerQuery()
  const myUserId = me!.viewer.userId

  const { data, loading, error, fetchMore, subscribeToMore } = useGetTimelinePostsQuery({
    fetchPolicy: 'network-only',
    nextFetchPolicy: 'cache-first',
    variables: {
      groupId: 0,
      sectionId: SectionType.Null,
      userId: myUserId,
      withViewerFollowing: false,
      withUserCreated: true,
      withAllPosts: false,
      withGroup: false,
      withSection: false,
      withDepartmentJournal: false,
      departmentId: 0,
      pagination: {
        last,
      },
      filter: {
        isArchived: true,
      },
      parentCommentPagination: {
        last: 0,
      },
    },
  })

  if (error) {
    return null
  }

  const posts = (data ? data.user!.posts.edges : [])
    .slice()
    .reverse()
    .map(({ node }) => node)
  const pageInfo = data
    ? data.user!.posts.pageInfo
    : {
        startCursor: null,
        endCursor: null,
        hasPreviousPage: false,
        hasNextPage: false,
      }

  const loadingComponent = loading && (
    <div className={s.loading}>
      <Spin delay={300} size='large' />
    </div>
  )

  return (
    <InfiniteScroll
      dataLength={posts.length}
      loader={loadingComponent}
      className={s.postList}
      hasMore={pageInfo.hasPreviousPage}
      next={() => {
        fetchMore({
          variables: {
            pagination: {
              last,
              before: pageInfo.startCursor,
            },
          },
        })
      }}
    >
      {posts.map((p) => (
        <PostCard key={p.postId} post={p} subscribeToMore={subscribeToMore} />
      ))}
    </InfiniteScroll>
  )
}
